import React from 'react'
import SelectField from 'material-ui/SelectField'
import MenuItem from 'material-ui/MenuItem'
import { useState } from 'react'
import { useEffect } from 'react'
import { useMemo } from 'react'

const styles = {
  datePickerContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  inputTitle: {
    fontSize: 14,
    fontWeight: 500,
    color: '#333',
    marginBottom: 8,
  },
  dropdownContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: 8,
    width: '100%',
  },
  dayDropdown: {
    flex: 1,
    maxWidth: 60,
    height: 44,
  },
  monthDropdown: {
    flex: 2,
    maxWidth: 110,
    height: 44,
  },
  selectFieldStyle: error => ({
    backgroundColor: 'white',
    height: 40,
    borderRadius: 8,
    border: '1px solid #E2E2FC',
    borderColor: error ? '#FF0000' : '#E2E2FC',
    width: '100%',
    fontSize: 14,
    paddingLeft: 12,
  }),
  errorMessage: {
    color: '#FF0000',
    fontSize: 12,
    marginTop: 4,
  },
}

const DayAndMonthSelector = ({
  value,
  onChange,
  validationErrors,
  validationKey,
  label,
}) => {
  const [month, setMonth] = useState(() => {
    if (value && value !== '-') {
      const [monthStr] = value.split('-')
      return monthStr && monthStr !== '' ? monthStr : null
    }
    return null
  })
  const [day, setDay] = useState(() => {
    if (value && value !== '-') {
      const [, dayStr] = value.split('-')
      return dayStr && dayStr !== '' ? dayStr : null
    }
    return null
  })

  useEffect(() => {
    if (day !== null && month !== null) {
      onChange(`${month}-${day}`)
    }
  }, [month, day])

  const MONTH_OPTIONS = [
    { label: 'January', value: '01', dateValue: 0 },
    { label: 'February', value: '02', dateValue: 1 },
    { label: 'March', value: '03', dateValue: 2 },
    { label: 'April', value: '04', dateValue: 3 },
    { label: 'May', value: '05', dateValue: 4 },
    { label: 'June', value: '06', dateValue: 5 },
    { label: 'July', value: '07', dateValue: 6 },
    { label: 'August', value: '08', dateValue: 7 },
    { label: 'September', value: '09', dateValue: 8 },
    { label: 'October', value: '10', dateValue: 9 },
    { label: 'November', value: '11', dateValue: 10 },
    { label: 'December', value: '12', dateValue: 11 },
  ]

  const getDaysInMonth = month => {
    if (!month) return 31
    const currentYear = new Date().getFullYear()
    return new Date(currentYear, month + 1, 0).getDate()
  }

  const getDayOptions = month => {
    const daysInMonth = getDaysInMonth(month)
    return Array.from({ length: daysInMonth }, (_, i) => {
      const day = i + 1
      return day < 10 ? `0${day}` : `${day}`
    })
  }

  const daysOptions = useMemo(() => {
    const monthValue = MONTH_OPTIONS.find(monthItem => monthItem.value == month)
    return getDayOptions(monthValue ? monthValue.dateValue : null)
  }, [month])

  return (
    <div style={styles.datePickerContainer}>
      <div style={styles.inputTitle}>{label}</div>
      <div style={styles.dropdownContainer}>
        <div style={styles.monthDropdown}>
          <SelectField
            hintText="Month"
            value={month}
            onChange={(event, index, value) => {
              setMonth(value)
              setDay(null)
            }}
            style={styles.selectFieldStyle(validationErrors[validationKey])}
            labelStyle={{
              color: '#333',
              fontSize: 14,
              lineHeight: '44px',
              padding: 0,
              paddingLeft: 12,
            }}
            hintStyle={{
              color: '#333',
              fontSize: 14,
              padding: 0,
              bottom: 8,
            }}
            iconStyle={{ padding: 0, height: 44, right: -12 }}
            underlineShow={false}
          >
            {MONTH_OPTIONS.map((month, index) => (
              <MenuItem
                key={index}
                value={month.value}
                primaryText={month.label}
                style={{ paddingLeft: 12 }}
              />
            ))}
          </SelectField>
        </div>
        <div style={styles.dayDropdown}>
          <SelectField
            hintText="Day"
            value={day}
            onChange={(event, index, value) => {
              setDay(value)
            }}
            style={styles.selectFieldStyle(validationErrors[validationKey])}
            labelStyle={{
              color: '#333',
              fontSize: 14,
              lineHeight: '44px',
              padding: 0,
              paddingLeft: 12,
            }}
            hintStyle={{
              color: '#333',
              fontSize: 14,
              padding: 0,
              bottom: 8,
            }}
            iconStyle={{ padding: 0, height: 44, right: -12 }}
            underlineShow={false}
          >
            {daysOptions.map(day => (
              <MenuItem
                key={day}
                value={day}
                primaryText={day}
                style={{ paddingLeft: 12 }}
              />
            ))}
          </SelectField>
        </div>
      </div>
      {validationErrors[validationKey] && (
        <div style={styles.errorMessage}>{validationErrors[validationKey]}</div>
      )}
    </div>
  )
}

export default DayAndMonthSelector
